import VerificationPage from "./components/VerificationPage";
import { useContext } from "react";
import {
  verificationContext,
  VerificationProvider,
  ContextType,
} from "./context/VerificationContext";
import Typography from "@mui/material/Typography";
import { EmrDataProvider } from "../../EMR";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import moduleRoutes from "../../routes/moduleRouteList";
import insuranceRouteList from "../routeList";
const baseRouteUrl = (window as any)._env_?.BASE_URL;
function Content() {
  const { setView, patientIdDetails } = useContext(
    verificationContext
  ) as ContextType;
  const navigate = useNavigate();
  const navigateBack = () => {
    setView(true);
    if (Boolean(patientIdDetails)) {
      navigate(-1);
    } else {
      navigate(
        `${baseRouteUrl}${moduleRoutes.mainRoute}/${moduleRoutes.insurance}/${insuranceRouteList.Verification}/`,
        {
          replace: true,
        }
      );
    }
  };
  return (
    <>
      <div className="py-2 border-b-2 flex justify-between items-center">
        <Typography
          variant="h6"
          fontSize={".9rem"}
          fontWeight={"600"}
          className="text-gray-500 ps-3"
        >
          {Boolean(patientIdDetails) ? "EMR DETAILS" : "INSURANCE VERIFICATION"}
        </Typography>

        <Button
          startIcon={<ArrowBackIcon />}
          className="!mt-2 !mr-5"
          color="error"
          onClick={navigateBack}
        >
          Back
        </Button>
      </div>
      <div>
        <VerificationPage />
      </div>
    </>
  );
}

function Index() {
  return (
    <EmrDataProvider>
      <VerificationProvider>
        <Content />
      </VerificationProvider>
    </EmrDataProvider>
  );
}

export default Index;
